import config from "../config";

export const KAKAO_AUTH_URL_SIGNUP = `https://kauth.kakao.com/oauth/authorize?client_id=${config.CLIENT_ID}&redirect_uri=${config.REDIRECT_URI_SIGNUP}&response_type=code`;